const seatIdentifierTypeWritten = (seatIdentifierType) => {
  switch (seatIdentifierType) {
    case 'incumbentName':
      return 'Incumbent';
    case 'seat':
      return 'Seat';
    case 'post':
      return 'Post';
    case 'division':
      return 'Division';
    case 'position':
      return 'Position';
    default:
      return null;
  }
};

const raceDistrictDisplayText = (race) => {
  const districtName = race?.originalDistrict?.longName || race?.district?.longName;
  const seatIdentifier = race?.positionData?.seatIdentifier;
  const seatIdentifierType = seatIdentifierTypeWritten(race?.positionData?.seatIdentifierType);
  const seatIdentifierText = (seatIdentifier || seatIdentifierType)
    ? [seatIdentifierType, seatIdentifier].filter(Boolean).join(' ')
    : null;
  const specialElectionText = race?.positionData?.special ? 'Special' : null;

  return [districtName, seatIdentifierText, specialElectionText]
    .filter(Boolean)
    .join(' • ');
};

export {
  seatIdentifierTypeWritten,
  raceDistrictDisplayText,
};
